import SearchInput from "../Inputs/Search";
import Category from "../Inputs/Category";
import { Button, MenuItem, Stack, Tab, Tabs, TextField } from "@mui/material";
import { useContext } from "react";
import UserContext from "../../services/Context/UserContext";
import { Add} from "@mui/icons-material";
import { Link } from "react-router-dom";
import { txt } from "../../services/translation";
import frenchCountries from "../../config/frenchCountries";

export default function Search({value, onChange}){

    const {user} = useContext(UserContext)

    return <Stack gap={1}>
        <Stack direction='row' flexWrap='wrap'>

            <SearchInput
                value={value.fast}
                onChange={e => onChange({...value, fast: e.target.value})}
                sx={{width: 220, m: 1}}
            />

            <Category
                value={value.category}
                onChange={category => onChange({...value, category})}
                sx={{width: 220, m: 1}}
            />

            {frenchCountries.includes(user.country) && <>

                <TextField
                    label={txt('chargeLabel')}
                    value={value.badge}
                    onChange={e => onChange({...value, badge: e.target.value})}
                    select
                    size='small'
                    sx={{width: 220, m: 1}}
                >
                    <MenuItem value='all'>{txt('all')}</MenuItem>
                    <MenuItem value='OFFERT'>{txt('offered')}</MenuItem>
                    <MenuItem value='DPC'>DPC</MenuItem>
                    <MenuItem value='FIFPL'>FIFPL</MenuItem>
                    <MenuItem value='OPCO'>OPCO</MenuItem>
                    <MenuItem value='FAFPM'>FAFPM</MenuItem>
                    <MenuItem value='pi'>{txt('integratedProgram')}</MenuItem>
                </TextField>

            </>}

            <TextField
                label={txt('productedBy')}
                value={value.owner}
                onChange={e => onChange({...value, owner: e.target.value})}
                select
                size='small'
                sx={{width: 220, m: 1}}
            >
                <MenuItem value='84264658000022'>LearnyLib</MenuItem>
                <MenuItem value='79500130400018'>Biotech Dental</MenuItem>
                <MenuItem value='all'>{txt('all2')}</MenuItem>
            </TextField>

            <TextField
                label={txt('sortByLabel')}
                value={value.order}
                onChange={e => onChange({...value, order: e.target.value})}
                select
                size='small'
                sx={{width: 120, m: 1}}
            >
                <MenuItem value='date'>{txt('date')}</MenuItem>
                <MenuItem value='rating'>{txt('rating')}</MenuItem>
                <MenuItem value='title'>{txt('title')}</MenuItem>
            </TextField>

            {user?.roles?.includes('creator') && 
                
                <Link to='/design/new'>
                    <Button
                        startIcon={<Add />}
                        variant='contained'
                        sx={{m: 1}}
                    >
                        {txt('addButton')}
                    </Button>
                </Link>
            }

        </Stack>
        <Tabs 
            value={value.kind} 
            onChange={(_, kind) => onChange({...value, kind})} 
            sx={{ borderBottom: 'solid 1px lightgrey', alignSelf: 'flex-start' }}
        >
            <Tab label="Formations" value="elearning" />
            <Tab label="MasterClass" value="masterclass" />
            <Tab label="LearnySpeed" value="learnyspeed" />
        </Tabs>   
    </Stack>;
}